import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import React from "react";
import {
    AsidePanelListViewSettingsHOC
} from "../react_components/aside_panel/asidePanel/hocs/AsidePanelListViewSettingsHOC/AsidePanelListViewSettingsHOC";

App.Views.ListViewSettings = App.Views.BaseView.extend({
    asideClassName: 'aside-panel__list-view-settings',

    initialize: function (options) {
        this.root = createRoot(this.el);
        this.store = options.store;
        this.parent = options.parent;
    },

    render: function () {
        this.parent.$el.find('.aside-panel__hide').hide();
        this.root.render(
            <Provider store={this.store}>
                <AsidePanelListViewSettingsHOC
                    closedRef={document.activeElement}
                />
            </Provider>
        );
        return this;
    },

    remove: function () {
        this.parent.$el.find('.aside-panel__hide').show();
        setTimeout(() => {
            setTimeout(() => {
                this.root.unmount(); // надо дождаться пока сработает react onblur, только потом отцеплять конпонент
            });
        });
        Backbone.View.prototype.remove.call(this);
    }
});

export default App.Views.ListViewSettings;
